// For authentication
export const LOG_IN_WITH_PASSWORD = "LOG_IN_WITH_PASSWORD";
export const LOG_IN_WITH_GOOGLE = "LOG_IN_WITH_GOOGLE";
export const LOG_IN_WITH_TWITTER = "LOG_IN_WITH_TWITTER";
export const LOG_IN_WITH_GITHUB = "LOG_IN_WITH_GITHUB";
export const SIGN_UP_WITH_PASSWORD = "SIGN_UP_WITH_PASSWORD";
export const LOG_OUT = "LOG_OUT";

// For note
export const ADD_NOTE = "ADD_NOTE";
export const ADD_NOTE_TO_SHORTCUT = "ADD_NOTE_TO_SHORTCUT";
export const DELETE_NOTE = "DELETE_NOTE";
export const GET_ALL_NOTES = "GET_ALL_NOTES";
export const MOVE_NOTE = "MOVE_NOTE";
export const MOVE_NOTE_TO_TRASH = "MOVE_NOTE_TO_TRASH";
export const REMOVE_NOTE_FROM_SHORTCUT = "REMOVE_NOTE_FROM_SHORTCUT";
export const RESTORE_NOTE = "RESTORE_NOTE";
export const SELECT_NOTE = "SELECT_NOTE";
export const SHARE_NOTE = "SHARE_NOTE";
export const SUBMIT_NOTE_CONTENT = "SUBMIT_NOTE_CONTENT";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const UPDATE_MULTIPLE_NOTES = "UPDATE_MULTIPLE_NOTES";
export const DELETE_MULTIPLE_NOTES = "DELETE_MULTIPLE_NOTES";

// For notebook
export const ADD_NOTEBOOK = "ADD_NOTEBOOK";
export const ADD_NOTEBOOK_TO_SHORTCUT = "ADD_NOTEBOOK_TO_SHORTCUT";
export const DELETE_NOTEBOOK = "DELETE_NOTEBOOK";
export const GET_ALL_NOTEBOOKS = "GET_ALL_NOTEBOOKS";
export const MOVE_NOTEBOOK_TO_TRASH = "MOVE_NOTEBOOK_TO_TRASH";
export const REMOVE_NOTEBOOK_FROM_SHORTCUT = "REMOVE_NOTEBOOK_FROM_SHORTCUT";
export const UPDATE_NOTEBOOK = "UPDATE_NOTEBOOK";
export const RESTORE_NOTEBOOK = "RESTORE_NOTEBOOK";
export const SELECT_NOTEBOOK = "SELECT_NOTEBOOK";
export const SHARE_NOTEBOOK = "SHARE_NOTEBOOK";

// For note/notebook that is shared with us
export const GET_ALL_SHARED_NOTES = "GET_ALL_SHARED_NOTES";
export const GET_ALL_SHARED_NOTEBOOKS = "GET_ALL_SHARED_NOTEBOOKS";

// For loading status
export const SET_LOADING_STATUS = "SET_LOADING_STATUS";
export const GET_LOADING_STATUS = "GET_LOADING_STATUS";
export const SET_NOTES_LOADING_STATUS = "SET_NOTES_LOADING_STATUS";
export const SET_NOTEBOOKS_LOADING_STATUS = "SET_NOTEBOOKS_LOADING_STATUS";

// For error message
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const GET_ERROR_MESSAGE = "GET_ERROR_MESSAGE";

// For user and authentication status
export const GET_CURRENT_USER = "GET_CURRENT_USER";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_AUTH_STATUS = "SET_AUTH_STATUS";
export const GET_AUTH_STATUS = "GET_AUTH_STATUS";

// For default notebook
export const MY_HOME = "My Home";
